import React, { memo, useState, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Badge,
  useTheme,
  useMediaQuery,
  Grid,
  Card,
  CardContent,
  Divider,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Skeleton,
  Tooltip,
  CircularProgress,
  Tabs,
  Tab
} from '@mui/material';
import {
  ShoppingCart as CartIcon,
  Add as AddIcon,
  Remove as RemoveIcon,
  Delete as DeleteIcon,
  Close as CloseIcon,
  LocalShipping as ShippingIcon,
  CreditCard as CreditCardIcon,
} from '@mui/icons-material';
import { useCart } from '../contexts/CartContext';
import { usePrescription } from '../contexts/PrescriptionContext';
import DatabaseService from '../services/DatabaseService';
import OrderConfirmation from './OrderConfirmation';
import { Order } from '../types';
import axios from 'axios';
import EmailService from '../services/EmailService';
import CartLogo from '../assets/CartLogo.png';
import closeIcon from '../assets/closeIcon.png'
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthService } from '../services/AuthService';
import PaymentService from '../services/PaymentService';


import image_not_found from '../assets/image_not_found.png';
import { checkImageURL } from '../utils/validations';
import { getImageSrc } from 'utils/imageUtils';
import PanierPng from '../assets/panier.png';
import PartnerCartIcon from '../assets/partner/Vector (6).png';
import PhoneNumberField from '../utils/PhoneNumberField';
// Payment Method Icons as SVG Components
const PaymentIcons = {
  visa: () => (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="4" fill="#1A1F71" />
      <path d="M16.5 7h2.8l-1.8 10h-2.8l1.8-10zm7.2 0l-2.6 10h-2.6l1.3-5.2-1.5 5.2h-1.5l-.3-5.2-1.3 5.2h-2.6l2.6-10h3.8l.2 3.8 1.1-3.8h3.4zm-12.4 0l-2.8 10h-2.8l-1.8-7.5-.8 7.5h-2.8l2.6-10h4.2l1.1 4.5.9-4.5h2.2z" fill="white" />
    </svg>
  ),
  mastercard: () => (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="4" fill="#EB001B" />
      <circle cx="15" cy="12" r="7" fill="#FF5F00" />
      <circle cx="25" cy="12" r="7" fill="#F79E1B" />
      <path d="M20 6.5c1.5 1.5 2.5 3.7 2.5 6s-1 4.5-2.5 6c-1.5-1.5-2.5-3.7-2.5-6s1-4.5 2.5-6z" fill="#FF5F00" />
    </svg>
  ),
  amex: () => (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="4" fill="#006FCF" />
      <path d="M8 7h6l1 2 1-2h6v10h-6l-1-2-1 2H8V7zm2 2v6h2l1-1.5L14 15h2V9h-2l-1 1.5L12 9h-2z" fill="white" />
    </svg>
  ),
  paypal: () => (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="4" fill="#003087" />
      <path d="M12 7c2.2 0 4 1.8 4 4s-1.8 4-4 4h-2l-.5 2h-2l1.5-6h3zm8 0c2.2 0 4 1.8 4 4s-1.8 4-4 4h-2l-.5 2h-2l1.5-6h3z" fill="#009CDE" />
    </svg>
  ),
  applePay: () => (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="4" fill="#000" />
      <path d="M16.5 8c-.5-.6-.8-1.4-.7-2.2.7.1 1.5.5 2 1.1.4.5.8 1.3.7 2-.8 0-1.5-.4-2-1zm.4 1.3c1.1-.1 2.1.6 2.6.6s1.6-.6 2.7-.5c1.4.1 2.4.8 3.1 2-.1.1-1.8 1-1.8 3 0 2.4 2.1 3.2 2.1 3.2s-.3 1-1 2c-.6.9-1.3 1.8-2.3 1.8s-1.3-.6-2.5-.6-1.6.6-2.5.6-1.6-.8-2.3-1.8c-1.4-2-2.5-5.7-1-8.2.7-1.2 2-2 3.4-2.1z" fill="white" />
    </svg>
  ),
  googlePay: () => (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="4" fill="#4285F4" />
      <path d="M20 9v2.4h3.97c-.16 1.03-1.2 3.02-3.97 3.02-2.39 0-4.34-1.98-4.34-4.42s1.95-4.42 4.34-4.42c1.36 0 2.27.58 2.79 1.08l1.9-1.83C23.47 3.69 21.89 3 20 3c-3.87 0-7 3.13-7 7s3.13 7 7 7c4.04 0 6.72-2.84 6.72-6.84 0-.46-.05-.81-.11-1.16H20z" fill="white" />
    </svg>
  ),
  klarna: () => (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="4" fill="#FFB3C7" />
      <path d="M12 7v10h2V7h-2zm4 0v4l3-4h2.5l-3.5 4.5L22 17h-2.5l-2.5-3.5-1 1.5V17h-2V7h2z" fill="#000" />
    </svg>
  ),
  bankTransfer: () => (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="4" fill="#2E7D32" />
      <path d="M8 8h24v2H8V8zm0 4h16v2H8v-2zm0 4h20v2H8v-2z" fill="white" />
      <circle cx="32" cy="12" r="3" fill="white" />
      <path d="M32 10v4l2-2-2-2z" fill="#2E7D32" />
    </svg>
  )
};
interface CustomerInfo {
  name: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  postalCode: string;
  country: string;
  // Removed firstName and lastName, use name only
  paymentMethod?: string;
}

// Use the direct API URL
const API_BASE_URL = 'https://api.tachafy.com';

// Helper to build a stable storage key per Stripe session
const handledKey = (sid: string) => `stripe:sid:${sid}:handled`;

export const ShoppingCart: React.FC = () => {
  const { items, removeFromCart, updateQuantity, total, clearCart, partnerOrders, activePartnerId, updatePartnerPaymentMethod, clearPartnerCart } = useCart();
  const activeOrder = partnerOrders.find(o => o.partnerId === activePartnerId);
  console.log('[ShoppingCart] Active Order:', activeOrder);
  const { validateOrder, prescriptionInCart, getPrescriptionPdfAsBase64 } = usePrescription();
  const [open, setOpen] = useState(false);
  const [customerInfo, setCustomerInfo] = useState<CustomerInfo>({
    name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: '',
    country: 'Tunisia',
    paymentMethod: undefined
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [completedOrder, setCompletedOrder] = useState<Order | null>(null);
  const [placingErrorOrder, setPlacingErrorOrder] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const badgeColor = ['/home', '/about-us', '/partnerpage', '/partner-form'].includes(location.pathname) ? '#d5006e' : '#C37559';
  const [paymentStatus, setPaymentStatus] = useState<'success' | 'failure' | null>(null);
  const [paymentSessionId, setPaymentSessionId] = useState<string | null>(null);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [orderFinalized, setOrderFinalized] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  // Centralized delivery fee configuration (should match backend)
  const DELIVERY_FEE = 7.0;
  const FREE_DELIVERY_THRESHOLD = 200.0;


  const [deliveryFee, setDeliveryFee] = useState(DELIVERY_FEE);
  const [isFreeDelivery, setIsFreeDelivery] = useState(false);
  const orderIdRef = useRef<string | null>(null);
  const emailSentRef = useRef(false);


  // Check for session_id in URL after redirect from checkout
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const session_id = params.get('session_id');
    const paymentSuccess = params.get('payment') === 'success';


    if ((session_id || paymentSuccess) && !orderFinalized) {
      setCheckoutLoading(true);


      if (session_id) {
        setPaymentSessionId(session_id);


        // Get order details by session_id
        PaymentService.getOrderBySession(session_id)
          .then((orderData) => {
            if (orderData.payment_status === 'paid') {
              // Get cart items from localStorage or use current items
              const savedItems = JSON.parse(localStorage.getItem('pendingOrderItems') || '[]');
              const orderProducts = savedItems.map((item: any) => ({
                productId: item.product?.id || item.productId, // Handle both raw and nested product
                productName: item.product?.name || item.productName,
                quantity: item.quantity,
                price: item.product?.price || item.price
              }));

              // Payment successful - show order confirmation
              const order: Order = {
                id: orderData.order_id,
                userId: orderData.customer_info.email,
                products: orderProducts, // Use actual cart items instead of empty array
                status: orderData.status as 'pending' | 'approved' | 'shipped' | 'completed' | 'cancelled',
                totalAmount: orderData.total,
                customerInfo: orderData.customer_info,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
              };

              setCompletedOrder(order);
              setConfirmationOpen(true);
              setPaymentStatus('success');
              clearCart(); // Clear cart after successful payment
              setOrderFinalized(true);
            } else {
              // Payment failed or pending
              setPaymentStatus('failure');
            }
          })
          .catch((error) => {
            console.error('Error getting order by session:', error);
            setPaymentStatus('failure');
          })
          .finally(() => {
            setCheckoutLoading(false);
          });
      } else if (paymentSuccess) {
        // Handle payment=success without session_id
        setPaymentStatus('success');
        clearCart(); // Clear cart after successful payment
        setOrderFinalized(true);
        setCheckoutLoading(false);
      }

      // Clean up URL by removing session_id and payment parameters
      params.delete('session_id');
      params.delete('payment');
      const newUrl = window.location.origin + window.location.pathname +
        (params.toString() ? '?' + params.toString() : '');
      window.history.replaceState({}, '', newUrl);
    }
  }, [orderFinalized, clearCart, items]);

  const handleQuantityChange = (productId: string, delta: number, currentQuantity: number) => {
    updateQuantity(productId, currentQuantity + delta);
  };

  // --- Checkout logic - handles both online payment and payment on delivery ---
  const handleCheckout = async (order: any) => {
    console.log('handleCheckout called with customerInfo:', customerInfo);

    // Validate inputs
    if (!customerInfo.name || !customerInfo.email || !customerInfo.phone ||
      !customerInfo.address || !customerInfo.city || !customerInfo.postalCode ||
      !customerInfo.country) {
      alert('Please fill in all required fields');
      return;
    }

    if (!customerInfo.paymentMethod) {
      alert('Please select a payment method');
      return;
    }

    // Ensure we have items to checkout
    if (!activeOrder?.items?.length) {
      alert('No items in cart to checkout');
      return;
    }

    // Save cart items to localStorage for retrieval after payment
    localStorage.setItem('pendingOrderItems', JSON.stringify(activeOrder.items));

    // Reset email sent flag for new checkout
    setEmailSent(false);
    emailSentRef.current = false;

    setIsSubmitting(true);
    try {
      // Build cart_items array for API - now guaranteed to exist
      const cart_items = activeOrder.items.map(item => ({
        product_id: item.product.id,
        name: item.product.name,
        quantity: item.quantity,
        price: item.product.price
      }));

      //localStorage.setItem('CartItems', JSON.stringify(cart_items));


      // Build customer_info for API
      const customer_info = {
        name: customerInfo.name,
        email: customerInfo.email,
        phone: customerInfo.phone,
        address: customerInfo.address,
        city: customerInfo.city,
        postalCode: customerInfo.postalCode,
        country: customerInfo.country,
        paymentMethod: customerInfo.paymentMethod,
      };


      // Use email as user_id
      const user_id = customerInfo.email;
      // Use EUR as currency
      const currency = 'eur';

      if (customerInfo.paymentMethod === 'online') {
        // ONLINE PAYMENT - Use existing Stripe checkout flow
        const return_url = window.location.origin + window.location.pathname;
        const payload = {
          user_id,
          cart_items,
          customer_info,
          currency,
          return_url
        };

        const { checkout_url } = await PaymentService.createCheckoutSession(payload);
        if (!checkout_url || typeof checkout_url !== 'string') {
          setPlacingErrorOrder('Payment session could not be created. Please try again or contact support.');
          setIsSubmitting(false);
          return;
        }
        window.location.href = checkout_url;
      } else if (customerInfo.paymentMethod === 'delivery') {
        // PAYMENT ON DELIVERY - Create order directly
        const payload = {
          user_id,
          cart_items,
          customer_info,
          currency,
          payment_method: 'delivery'
        };

        console.debug('[PaymentService] PAYMENT ON DELIVERY Payload:', payload);
        const result = await PaymentService.createOrderDirectly(payload);
        console.log('[PaymentService] PAYMENT ON DELIVERY Result:', result);
        if (result.success) {
          // Create order object for confirmation dialog
          const orderProducts = activeOrder.items.map(item => ({
            productId: item.product.id,
            productName: item.product.name,
            quantity: item.quantity,
            price: item.product.price
          }));

          const completedOrder: Order = {
            id: result.order_id,
            userId: customerInfo.email,
            products: orderProducts,
            status: 'pending',
            totalAmount: result.total_amount,
            customerInfo,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          };

          // Clear cart and show order confirmation dialog
          setCompletedOrder(completedOrder);
          clearCart();
          setConfirmationOpen(true);
          setOrderFinalized(true);

          // Send order confirmation email using EmailService
          try {
            const emailService = new EmailService();
            await emailService.sendOrderConfirmation(completedOrder, true);
            console.log('Order confirmation email sent successfully');
            setEmailSent(true);
            emailSentRef.current = true;
          } catch (emailError) {
            console.error('Failed to send order confirmation email:', emailError);
          }
        } else {
          setPlacingErrorOrder('Failed to create order. Please try again.');
        }
      }
    } catch (error) {
      console.error('Error during checkout:', error);
      setPlacingErrorOrder('Error processing checkout. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  // Optimize image loading with progressive loading
  const OptimizedImage = memo(({ src, alt, height, width, className }: {
    src: string,
    alt: string,
    height?: string | number,
    width?: string | number,
    className?: string
  }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const validImageUrl = checkImageURL(src);

    return (
      <>
        {loading && !error && (
          <Skeleton
            variant="rectangular"
            width={width || '100%'}
            height={height || 140}
            animation="wave"
            aria-label="Loading image"
          />
        )}
        <img
          src={src}
          alt={alt}
          style={{
            display: loading || error ? 'none' : 'block',
            height,
            width,
            objectFit: 'cover'
          }}
          className={className}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
        {error && (
          <img
            src={image_not_found}
            alt="Image not found"
            className={className} />
        )}
      </>
    );
  });

  // Utility function to truncate description to a certain number of words
  const truncateDescription = (desc: string, wordLimit: number = 12) => {
    if (!desc) return '';
    const words = desc.split(' ');
    if (words.length <= wordLimit) return desc;
    return words.slice(0, wordLimit).join(' ') + '...';
  };

  const renderMobileCartItems = () => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {items.map(item => (
          <Card key={item.product.id} sx={{ mb: 1 }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '0.95rem' }}>
                  {item.product.name}
                </Typography>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => removeFromCart(item.product.id)}
                  sx={{ p: 0.5 }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
                  {item.product.price.toFixed(3)} TND
                </Typography>
                {/* Truncated description for mobile cart */}
                <Typography variant="body2" sx={{ color: '#666', fontSize: '0.85rem', mt: 0.5 }}>
                  {truncateDescription(item.product.description || 'Product description')}
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    size="small"
                    onClick={() => handleQuantityChange(item.product.id, -1, item.quantity)}
                    sx={{ p: 0.5 }}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                  <Typography sx={{ mx: 1, fontSize: '0.9rem' }}>{item.quantity}</Typography>
                  <IconButton
                    size="small"
                    onClick={() => handleQuantityChange(item.product.id, 1, item.quantity)}
                    sx={{ p: 0.5 }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Box>

                <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '0.95rem' }}>
                  {(item.product.price * item.quantity).toFixed(3)} TND
                </Typography>
              </Box>
            </CardContent>
          </Card>
        ))}

        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mt: 2,
          pt: 2,
          borderTop: `1px solid ${theme.palette.divider}`,
          fontWeight: 600
        }}>
          <Typography variant="subtitle1">Total:</Typography>
          <Typography variant="subtitle1">{total.toFixed(3)} TND</Typography>
        </Box>
      </Box>
    );
  };
  const isAuthenticated = () => {
    // Only check for user authentication, do not use localStorage for cart
    return !!localStorage.getItem("userEmail"); // or whatever auth logic you use
  };

  // Calculate delivery fee when cart total changes
  // Calculate delivery fee when cart changes
  useEffect(() => {
    if (activeOrder) {
      const partnerTotal = activeOrder.total;
      const calculatedFee = partnerTotal >= FREE_DELIVERY_THRESHOLD ? 0 : DELIVERY_FEE;
      setDeliveryFee(calculatedFee);
      setIsFreeDelivery(partnerTotal >= FREE_DELIVERY_THRESHOLD);
    } else {
      setDeliveryFee(DELIVERY_FEE);
      setIsFreeDelivery(false);
    }
  }, [activeOrder]); // Watch activeOrder instead of total

  useEffect(() => {
  const activeOrder = partnerOrders.find(o => o.partnerId === activePartnerId);
  if (activeOrder) {
    setCustomerInfo(prev => ({
      ...prev,
      paymentMethod: activeOrder.paymentMethod || '',
    }));
  }
}, [activePartnerId]);

  useEffect(() => {
    const savedCustomerInfo = localStorage.getItem('pendingCustomerInfo');
    if (savedCustomerInfo) {
      setCustomerInfo(JSON.parse(savedCustomerInfo));
      return;
    }
    const fetchUserInfo = async () => {
      const email = localStorage.getItem('userEmail');
      if (!email) return; // Not logged in

      try {
        const user = await AuthService.getUserByEmail(email);
        setCustomerInfo(prev => ({
          ...prev,
          name: (user.prenom ? user.prenom + ' ' : '') + (user.nom || ''),
          email: user.email || '',
          phone: user.telephone || '',
          address: user.adresse || '',
          city: user.ville || '',
          postalCode: user.code_postal || '',
          country: user.pays || 'Tunisia',
        }));
      } catch (err) {
        // fallback to empty/defaults if fetch fails
        setCustomerInfo(prev => ({
          ...prev,
          name: '',
          email: email,
          phone: '',
          address: '',
          city: '',
          postalCode: '',
          country: 'Tunisia',
        }));
      }
    };

    fetchUserInfo();
  }, []);


  const isFormComplete = (): boolean => {
    return (
      customerInfo.name.trim() !== '' &&
      customerInfo.email.trim() !== '' &&
      customerInfo.phone.trim() !== '' &&
      customerInfo.address.trim() !== '' &&
      customerInfo.country.trim() !== '' &&
      customerInfo.city.trim() !== '' &&
      customerInfo.postalCode.trim() !== '' &&
      customerInfo.paymentMethod !== undefined &&
      customerInfo.paymentMethod !== '' &&
      customerInfo.paymentMethod !== null
    );
  };

  useEffect(() => {
    // 1) Read the URL once (no deps; we’ll clean it after)
    const sp = new URLSearchParams(window.location.search);
    const status = sp.get("payment");
    const sid = sp.get("session_id");

    // Not a Stripe success return — exit fast
    if (status !== "success" || !sid) return;

    // 2) Idempotency in the browser: if this session_id was already handled in this tab, bail
    if (sessionStorage.getItem(handledKey(sid))) {
      // Defensive: strip the query to avoid future accidental triggers
      window.history.replaceState(null, "", window.location.pathname);
      return;
    }

    // 3) Mark as handled immediately to block any remount/resize duplicates
    sessionStorage.setItem(handledKey(sid), "1");

    // 4) Open your success UI once (it won’t reopen on remount/resize)
    setOrderFinalized(true);
    setConfirmationOpen(true);

    // 5) Optional: send your temporary client-side email exactly once
    (async () => {
      try {
        if (!emailSentRef.current) {
          const orderData = await PaymentService.getOrderBySession(sid);

          // Reuse your existing mapping logic here
          // Create order object for confirmation dialog using backend data
          const savedItems = JSON.parse(localStorage.getItem('pendingOrderItems') || '[]');

          const orderProducts = savedItems.map((item: any) => ({
            productId: item.product?.id || item.productId,
            productName: item.product?.name || item.productName,
            quantity: item.quantity,
            price: item.product?.price || item.price,
          }));

          const completedOrder: Order = {
            id: orderData.order_id,
            userId: orderData.customer_info.email,
            products: orderProducts,
            status: orderData.status as Order["status"],
            totalAmount: orderData.total,
            customerInfo: orderData.customer_info,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          };
          
          // Set completed order for confirmation dialog
          setCompletedOrder(completedOrder);

          const emailService = new EmailService();
          await emailService.sendOrderConfirmation(completedOrder, true);

          emailSentRef.current = true;
          setEmailSent(true);
        }
      } catch (err) {
        console.error("Stripe success handling failed:", err);
      } finally {
        // 6) Crucial: strip the query string so future mounts can’t retrigger
        window.history.replaceState(null, "", window.location.pathname);
      }
    })();

    // Empty deps by design — we manage idempotency ourselves.
  }, []);

  // Handle payment success when returning from Stripe
  // useEffect(() => {
  //   const urlParams = new URLSearchParams(location.search);
  //   const paymentStatus = urlParams.get('payment');
  //   const sessionId = urlParams.get('session_id');

  //   if (paymentStatus === 'success' && sessionId && !orderFinalized && !emailSentRef.current) {
  //     // Payment was successful, show order confirmation
  //     setOrderFinalized(true);
  //     setConfirmationOpen(true);

  //     // Mark email as sent immediately to prevent duplicates
  //     emailSentRef.current = true;
  //     setEmailSent(true);

  //     // Send order confirmation email for online payment
  //     const handlePaymentSuccess = async () => {
  //       try {
  //         const orderData = await PaymentService.getOrderBySession(sessionId);

  //         // Create order object for confirmation dialog using backend data
  //         const orderProducts = orderData.products ? orderData.products.map((product: any) => ({
  //           productId: product.productId,
  //           productName: product.productName,
  //           quantity: product.quantity,
  //           price: product.price
  //         })) : items.map(item => ({
  //           productId: item.product.id,
  //           productName: item.product.name,
  //           quantity: item.quantity,
  //           price: item.product.price
  //         }));

  //         const completedOrder: Order = {
  //           id: orderData.order_id,
  //           userId: orderData.customer_info.email,
  //           products: orderProducts,
  //           status: orderData.status as 'pending' | 'approved' | 'shipped' | 'completed' | 'cancelled',
  //           totalAmount: orderData.total, // Backend calculated total includes delivery fee
  //           customerInfo: orderData.customer_info,
  //           createdAt: new Date().toISOString(),
  //           updatedAt: new Date().toISOString()
  //         };

  //         // Set completed order for confirmation dialog
  //         setCompletedOrder(completedOrder);

  //         const emailService = new EmailService();
  //         await emailService.sendOrderConfirmation(completedOrder, true); // true to force send in development
  //         console.log('Order confirmation email sent successfully for online payment');
  //       } catch (emailError) {
  //         console.error('Failed to send order confirmation email for online payment:', emailError);
  //       }
  //     };

  //     handlePaymentSuccess();
  //   }
  // }, [location.search]); // Only depend on location.search to prevent multiple triggers

/*   // Ensure cart closes when order confirmation dialog opens
  useEffect(() => {
    if (confirmationOpen) {
      setOpen(false);
    }
  }, [confirmationOpen]); */

/*   // Force refresh cart state when order confirmation dialog closes
  useEffect(() => {
    if (!confirmationOpen && orderFinalized) {
      // Force a small delay to ensure cart state is properly updated
      const timer = setTimeout(() => {
        // This will trigger a re-render and show empty cart
        setOrderFinalized(false);
        // Reset email sent state when order is finalized
        setEmailSent(false);
        emailSentRef.current = false;
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [confirmationOpen, orderFinalized]); */

  const PartnerOrderTabs = () => {
    const { partnerOrders, activePartnerId, setActivePartner } = useCart();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        mb: 3,
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
          height: 6,
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: 3,
        },
        // Remove the default Tabs indicator
        '& .MuiTabs-indicator': {
          display: 'none',
        }
      }}>
        <Tabs
          value={activePartnerId || false}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: 56,
            '& .MuiTab-root': {
              textTransform: 'none',
              minWidth: 'auto',
              minHeight: 48,
              fontSize: '0.875rem',
              fontWeight: 600,
              color: theme.palette.text.secondary,
              opacity: 0.8,
              transition: 'all 0.2s ease',
              px: 2,
              mx: 0.5,
              borderRadius: '8px 8px 0 0',
              '&:hover': {
                color: '#131B5C',
                opacity: 1,
                backgroundColor: 'rgba(208, 0, 111, 0.05)',
              },
              '&.Mui-selected': {
                color: '#131B5C',
                fontWeight: 700,
                opacity: 1,
              },
              '&.Mui-focusVisible': {
                backgroundColor: 'rgba(208, 0, 111, 0.12)',
              },
            },
            '& .MuiTabScrollButton-root': {
              color: theme.palette.text.secondary,
              '&.Mui-disabled': {
                opacity: 0.3,
              },
            },
          }}
        >
          {partnerOrders.map(order => (
            <Tab
              key={order.partnerId}
              label={
                <Badge
                  badgeContent={order.items.length}
                  color="primary"
                  overlap="rectangular"
                  sx={{
                    '& .MuiBadge-badge': {
                      right: -7,
                      top: 2,
                      backgroundColor: '#C37559',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '0.6rem',
                      minWidth: 18,
                      height: 18,
                    },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      maxWidth: 160,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      pr: 1,
                    }}
                  >
                    {order.partnerName}
                  </Box>
                </Badge>
              }
              value={order.partnerId}
              onClick={() => setActivePartner(order.partnerId)}
              sx={{
                position: 'relative',
                // Single underline implementation
                '&:after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  right: '50%',
                  height: 3,
                  backgroundColor: 'transparent',
                  transition: 'all 0.2s ease',
                },
                '&.Mui-selected:after': {
                  left: 0,
                  right: 0,
                  backgroundColor: '#C37559',
                },
                '&:hover:after': {
                  left: 0,
                  right: 0,
                  backgroundColor: 'rgba(208, 0, 111, 0.3)',
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
    );
  };

  return (
    <>
      <style>{`
        .cart-dialog {
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        }
        
        .cart-header {
          background: linear-gradient(135deg, #717B61 0%, #717B61 100%);
          color: white;
          padding: 24px;
          position: relative;
        }
        
        .cart-close-btn {
          position: absolute;
          top: 16px;
          right: 16px;
          color: white;
          background: rgba(255,255,255,0.2);
          transition: all 0.2s ease;
        }
        
        .cart-close-btn:hover {
          background: rgba(255,255,255,0.3);
          transform: rotate(90deg);
        }
        
        .cart-item {
          transition: all 0.2s ease;
          border-radius: 12px;
        }
        
        .cart-item:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          transform: translateY(-2px);
        }
        
        .quantity-control {
          display: flex;
          align-items: center;
          border: 1px solid #E0E0E0;
          border-radius: 20px;
          padding: 4px;
        }
        
        .quantity-btn {
          width: 28px;
          height: 28px;
          min-width: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #131B5C;
          background: transparent;
          transition: all 0.2s ease;
        }
        
        .quantity-btn:hover {
          background: #F5F5F5;
        }
        
        .delete-btn {
          color: #C37559;
          transition: all 0.2s ease;
        }
        
        .delete-btn:hover {
          transform: scale(1.1);
        }
        
        .summary-card {
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          position: sticky;
          top: 20px;
        }
        
        .checkout-btn {
          background: linear-gradient(135deg, #C37559 0%, #B5674F 100%);
          color: white;
          border-radius: 50px;
          padding: 12px 24px;
          font-weight: 600;
          text-transform: none;
          letter-spacing: 0.5px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 8px rgba(195,117,89,0.2);
        }
        
        .checkout-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(195,117,89,0.3);
        }
        
        .checkout-btn:disabled {
          background: rgba(195,117,89,0.5);
          transform: none;
          box-shadow: none;
        }
        
        .payment-method-icon {
          transition: all 0.2s ease;
        }
        
        .payment-method-icon:hover {
          transform: translateY(-3px);
        }
        
        .free-delivery-badge {
          background: #E8F5E9;
          color: #2E7D32;
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 0.75rem;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          margin-left: 8px;
        }
        
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
        
        .pulse-animation {
          animation: pulse 1.5s infinite;
        }
      `}</style>

      <IconButton color="inherit"
        onClick={() => {
          if (isAuthenticated()) {
            setOpen(true); // open cart popup
          } else {
            navigate("/signIn");
          }
        }}
      >
        <Badge badgeContent={items.length} color="secondary"
          sx={{
            '& .MuiBadge-badge': {
              backgroundColor: badgeColor,
              color: '#fff',
            }
          }}
        >
          <img src={location.pathname === '/partnerpage' ? PartnerCartIcon : PanierPng} alt="Cart Icon" style={{ width: 30, height: 30, objectFit: 'contain', margin: 0, padding: 0, verticalAlign: 'middle' }} />
        </Badge>
      </IconButton>


      <Dialog
        open={open}
        onClose={() => !isSubmitting && setOpen(false)}
        maxWidth="md"
        fullWidth
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            width: { xs: '100vw', sm: '95vw', md: '90vw', lg: '85vw' },
            maxWidth: { xs: '100vw', sm: '95vw', md: '90vw', lg: '85vw' },
            m: { xs: 1, sm: 2 },
          }
        }}
        className="cart-dialog"
      >
        {/* Header Section */}
        <Box className="cart-header">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <CartIcon sx={{ fontSize: 32 }} />
            <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: '1.5rem', sm: '2rem' } }}>
              Shopping Cart
            </Typography>
          </Box>
          <Typography variant="subtitle1" sx={{ opacity: 0.9, mt: 1 }}>
            {items.length} {items.length === 1 ? 'item' : 'items'} in your cart
          </Typography>

          <IconButton
            className="cart-close-btn"
            onClick={() => !isSubmitting && setOpen(false)}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent sx={{
          p: 0,
          backgroundColor: '#FAFAFA',
          '&::-webkit-scrollbar': { width: '8px' },
          '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '4px' },
          '&::-webkit-scrollbar-thumb': { background: '#c1c1c1', borderRadius: '4px' },
          '&::-webkit-scrollbar-thumb:hover': { background: '#a8a8a8' },
        }}>
          {items.length === 0 ? (
            /* Empty Cart State */
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '50vh',
              p: 4,
              textAlign: 'center'
            }}>
              <Box sx={{
                width: 120,
                height: 120,
                backgroundColor: '#F4F2EE',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3,
              }}>
                <CartIcon sx={{ fontSize: 48, color: '#131B5C' }} />
              </Box>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
                Your cart is empty
              </Typography>
              <Typography variant="body1" sx={{ color: '#666', mb: 3, maxWidth: '400px' }}>
                Looks like you haven't added any items to your cart yet. Start shopping to find amazing products!
              </Typography>
              <Button
                
                className="checkout-btn"
                onClick={() => setOpen(false)}
                sx={{ px: 4 }}
              >
                Continue Shopping
              </Button>
            </Box>
          ) : (
            /* Cart with Items */
            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 3,
              p: { xs: 2, sm: 3 },
              minHeight: '60vh'
            }}>
              {/* Left Column - Cart Items */}
              <Box sx={{ flex: 2 }}>
                <PartnerOrderTabs />

                {/* Cart Items List */}
                <Box sx={{
                  backgroundColor: 'white',
                  borderRadius: 2,
                  p: { xs: 2, sm: 3 },
                  mb: 3
                }}>
                  <Typography variant="h6" sx={{
                    fontWeight: 600,
                    mb: 3,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}>
                    Orders from {activeOrder?.partnerName}
                  </Typography>

                  {activeOrder?.items.map((item, index) => (
                    <React.Fragment key={item.product.id}>
                      <Box className="cart-item" sx={{
                        display: 'flex',
                        gap: 2,
                        mb: 3,
                        p: 2,
                        backgroundColor: 'white'
                      }}>
                        {/* Product Image */}
                        <Box sx={{
                          width: 100,
                          height: 100,
                          borderRadius: 1,
                          overflow: 'hidden',
                          flexShrink: 0
                        }}>
                          <OptimizedImage
                            src={item.product.imageData || image_not_found}
                            alt={item.product.name}
                            width="100%"
                            height="100%"
                          />
                        </Box>

                        {/* Product Details */}
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start'
                          }}>
                            <Typography variant="subtitle1" sx={{
                              fontWeight: 600,
                              mb: 1,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              pr: 1
                            }}>
                              {item.product.name}
                            </Typography>
                            <IconButton
                              className="delete-btn"
                              onClick={() => removeFromCart(item.product.id)}
                              size="small"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>

                          <Typography variant="body2" sx={{
                            color: '#666',
                            mb: 2,
                            fontSize: '0.875rem'
                          }}>
                            {truncateDescription(item.product.description || 'Product description')}
                          </Typography>

                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}>
                            <Box className="quantity-control">
                              <IconButton
                                className="quantity-btn"
                                onClick={() => handleQuantityChange(item.product.id, -1, item.quantity)}
                                size="small"
                                disabled={item.quantity <= 1}
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                              <Typography sx={{
                                px: 1,
                                minWidth: 30,
                                textAlign: 'center',
                                fontWeight: 500
                              }}>
                                {item.quantity}
                              </Typography>
                              <IconButton
                                className="quantity-btn"
                                onClick={() => handleQuantityChange(item.product.id, 1, item.quantity)}
                                size="small"
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </Box>

                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                              {(item.product.price * item.quantity).toFixed(3)} TND
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      {index < activeOrder.items.length - 1 && (
                        <Divider sx={{ my: 2, borderColor: '#F0F0F0' }} />
                      )}
                    </React.Fragment>
                  ))}
                </Box>

                {/* Shipping Information */}
                <Box sx={{
                  backgroundColor: 'white',
                  borderRadius: 2,
                  p: { xs: 2, sm: 3 },
                  mb: 3
                }}>
                  <Typography variant="h6" sx={{
                    fontWeight: 600,
                    mb: 3,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}>
                    <ShippingIcon fontSize="small" />
                    Shipping Information
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Full Name"
                        value={customerInfo.name}
                        onChange={e => setCustomerInfo({ ...customerInfo, name: e.target.value })}
                        required
                        size="small"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            '&.Mui-focused fieldset': {
                              borderColor: '#C37559',
                            },
                          },
                          '& label.Mui-focused': {
                            color: '#C37559',
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Email"
                        type="email"
                        value={customerInfo.email}
                        onChange={e => setCustomerInfo({ ...customerInfo, email: e.target.value })}
                        required
                        size="small"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            '&.Mui-focused fieldset': {
                              borderColor: '#C37559',
                            },
                          },
                          '& label.Mui-focused': {
                            color: '#C37559',
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <PhoneNumberField
                        label="Phone Number"
                        value={customerInfo.phone}
                        onChange={(newPhone) => setCustomerInfo({ ...customerInfo, phone: newPhone })}
                        required={true}
                        disableGridWrapper={true}
                        useCForm={false}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            '&.Mui-focused fieldset': {
                              borderColor: '#C37559',
                            },
                          },
                          '& label.Mui-focused': {
                            color: '#C37559',
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Address"
                        value={customerInfo.address}
                        onChange={e => setCustomerInfo({ ...customerInfo, address: e.target.value })}
                        required
                        size="small"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            '&.Mui-focused fieldset': {
                              borderColor: '#C37559',
                            },
                          },
                          '& label.Mui-focused': {
                            color: '#C37559',
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="City"
                        value={customerInfo.city}
                        onChange={e => setCustomerInfo({ ...customerInfo, city: e.target.value })}
                        required
                        size="small"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            '&.Mui-focused fieldset': {
                              borderColor: '#C37559',
                            },
                          },
                          '& label.Mui-focused': {
                            color: '#C37559',
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Postal Code"
                        value={customerInfo.postalCode}
                        onChange={e => setCustomerInfo({ ...customerInfo, postalCode: e.target.value })}
                        required
                        size="small"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            '&.Mui-focused fieldset': {
                              borderColor: '#C37559',
                            },
                          },
                          '& label.Mui-focused': {
                            color: '#C37559',
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl fullWidth size="small">
                        <InputLabel sx={{
                          '&.Mui-focused': {
                            color: '#C37559',
                          }
                        }}>Country</InputLabel>
                        <Select
                          value={customerInfo.country}
                          label="Country"
                          onChange={e => setCustomerInfo({ ...customerInfo, country: e.target.value })}
                          sx={{
                            borderRadius: '8px',
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#C37559',
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                '& .Mui-selected': {
                                  backgroundColor: '#F0A6C7',
                                },
                                '& .Mui-selected:hover': {
                                  backgroundColor: '#C37559',
                                  color: 'white',
                                },
                              }
                            }
                          }}
                        >
                          <MenuItem value="Tunisia">Tunisia</MenuItem>
                          <MenuItem value="Libya">Libya</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>

                {/* Payment Method */}
                <Box sx={{
                  backgroundColor: 'white',
                  borderRadius: 2,
                  p: { xs: 2, sm: 3 }
                }}>
                  <Typography variant="h6" sx={{
                    fontWeight: 600,
                    mb: 3,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}>
                    <CreditCardIcon fontSize="small" />
                    Payment Method
                  </Typography>

                  <FormControl fullWidth size="small">
                    <InputLabel sx={{
                      '&.Mui-focused': {
                        color: '#C37559',
                      }
                    }}>Select Payment Method</InputLabel>
                    <Select
                      value={customerInfo.paymentMethod || ''}
                      onChange={(e) => {
                        if (activePartnerId) {
                          updatePartnerPaymentMethod(activePartnerId, e.target.value);
                          setCustomerInfo({ ...customerInfo, paymentMethod: e.target.value })
                        }
                      }}
                      sx={{
                        borderRadius: '8px',
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#C37559',
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            '& .Mui-selected': {
                              backgroundColor: '#F0A6C7',
                            },
                            '& .Mui-selected:hover': {
                              backgroundColor: '#C37559',
                              color: 'white',
                            },
                          }
                        }
                      }}
                    >
                      <MenuItem value="online">Online Payment (Credit/Debit Card)</MenuItem>
                      <MenuItem value="delivery">Payment on Delivery</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              {/* Right Column - Order Summary */}
              <Box sx={{ flex: 1, position: 'relative' }}>
                <Box className="summary-card" sx={{
                  backgroundColor: 'white',
                  p: { xs: 2, sm: 3 },
                  mb: 3
                }}>
                  <Typography variant="h6" sx={{
                    fontWeight: 600,
                    mb: 3,
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    Order Summary
                    {isFreeDelivery && (
                      <span className="free-delivery-badge">
                        Free Delivery
                      </span>
                    )}
                  </Typography>

                  <Box sx={{ mb: 2 }}>
                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      mb: 1.5
                    }}>
                      <Typography variant="body2" sx={{ color: '#666' }}>Subtotal</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {activeOrder?.total.toFixed(3)} TND
                      </Typography>
                    </Box>

                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      mb: 1.5
                    }}>
                      <Typography variant="body2" sx={{ color: '#666' }}>Delivery Fee</Typography>
                      <Typography variant="body2" sx={{
                        fontWeight: 500,
                        color: isFreeDelivery ? '#2E7D32' : 'inherit'
                      }}>
                        {isFreeDelivery ? 'FREE' : `${deliveryFee.toFixed(3)} TND`}
                      </Typography>
                    </Box>

                    {!isFreeDelivery && activeOrder && activeOrder.total > 0 && (
                      <Typography variant="caption" sx={{
                        color: '#666',
                        display: 'block',
                        textAlign: 'center',
                        mb: 2
                      }}>
                        Spend {(FREE_DELIVERY_THRESHOLD - activeOrder.total).toFixed(3)} TND more with {activeOrder.partnerName} for free delivery
                      </Typography>
                    )}

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      mb: 3
                    }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Total</Typography>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {activeOrder ? (activeOrder.total + (isFreeDelivery ? 0 : deliveryFee)).toFixed(3) : '0.000'} TND
                      </Typography>
                    </Box>

                    <Button
                      fullWidth
                      className={`checkout-btn `}
                      onClick={() => {
                        if (activeOrder) {
                          const order = {
                            id: `order_${Math.floor((Date.now() % 1000000) / 100)}${Math.floor(Math.random() * 100)}`,
                            userId: customerInfo.email,
                            products: activeOrder?.items.map(item => ({
                              productId: item.product.id,
                              productName: item.product.name,
                              quantity: item.quantity,
                              price: item.product.price
                            })),
                            status: 'pending',
                            totalAmount: total,
                            customerInfo,
                            createdAt: new Date().toISOString(),
                            updatedAt: new Date().toISOString()
                          };
                          handleCheckout(order);
                        }
                      }}
                      disabled={!isFormComplete() || isSubmitting || checkoutLoading || !activeOrder?.paymentMethod}
                    >
                      {isSubmitting || checkoutLoading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CircularProgress size={20} color="inherit" />
                          Processing...
                        </Box>
                      ) : (
                        ` Checkout`
                      )}
                    </Button>

                    {placingErrorOrder && (
                      <Typography variant="body2" color="error" sx={{
                        mt: 2,
                        textAlign: 'center',
                        fontSize: '0.75rem'
                      }}>
                        {placingErrorOrder}
                      </Typography>
                    )}
                  </Box>
                </Box>

                {/* Accepted Payment Methods */}
                <Box sx={{
                  backgroundColor: 'white',
                  borderRadius: 2,
                  p: { xs: 2, sm: 3 }
                }}>
                  <Typography variant="body2" sx={{
                    fontWeight: 600,
                    mb: 2,
                    color: '#666'
                  }}>
                    We Accept
                  </Typography>

                  <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    justifyContent: 'center'
                  }}>
                    {Object.entries(PaymentIcons).map(([key, IconComponent]) => (
                      <Box key={key} className="payment-method-icon">
                        <IconComponent />
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Order Confirmation Dialog */}
      <OrderConfirmation
        open={confirmationOpen}
        onClose={() => {
          setConfirmationOpen(false);
          setOrderFinalized(false);
        }}
        order={completedOrder}
      />
    </>
  );
};

export default ShoppingCart;